export const buildDate: string = "2026-09-27 08:29:38";
export const appState:number = 1;
